import {graphql, StaticQuery} from 'gatsby';
import {SmallHeader} from '@nib-components/header';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import {NibFonts} from '@nib/fonts';
import Theme from '@nib-components/theme';

export const PureLayout = (props) => {
  const {children, data, brand} = props;

  return (
    <Theme theme={brand.theme}>
      <NibFonts />
      <SmallHeader variation="arhi" />
      <Helmet>
        <title>{data.site.siteMetadata.title}</title>
        <meta name="description" content={data.site.siteMetadata.description} />
      </Helmet>
      <div>{children}</div>
    </Theme>
  );
};

PureLayout.propTypes = {
  children: PropTypes.object,
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

const Layout = ({children, brand}) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          site {
            siteMetadata {
              title
              description
            }
          }
        }
      `}
      render={(data) => (
        <PureLayout brand={brand} data={data}>
          {children}
        </PureLayout>
      )}
    />
  );
};

Layout.propTypes = {
  children: PropTypes.object,
};

export default Layout;
